/**
 * The `ch-tabular-grid-actionbar` component represents a container for a grid actions.
 */
export class ChTabularGridActionbar {
    el;
    static get is() { return "ch-tabular-grid-actionbar"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-actionbar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-actionbar.css"]
        };
    }
    static get elementRef() { return "el"; }
}
